module.exports = __webpack_public_path__ + "img/qualification_3.ecf91b80.png";